import React from 'react';

const NoData = props => {
  return (
    <div>
      <span className="fa-stack  fa-10x content-list-icon">
        <i className="fas fa-tasks" />
      </span>
      <span className="icon-legend">{props.legend}</span>
    </div>
  );
};

export default NoData;



// WEBPACK FOOTER //
// ./source/client/components/dynamic_list/NoData.jsx